import React from "react";

export default function ContactSection() {
  return (
    <div
      className="main_contact_area app pt-40 bg_fixed"
      
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side Image */}
          <div class="col-lg-7 pb-180">  
          <div className="section_main_title black text-left">
                <h5>Deliverables</h5>
          </div>       
            <div class="why-choose-icon " data-wow-delay=".5">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Contact potential or existing customers to verify the attributes given to them.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Answer questions about products or the company.</h6>
              </div>
              
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Direct prospects to the sales team when needed.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Enter and update customer information in the database.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Take and process orders in an accurate manner.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Handle grievances to preserve the company’s reputation.</h6>
              </div>
             
            </div>
            <div className="section_main_title black text-left mt-3">
                <h5>Requirements</h5>
            </div> 
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Proven experience as a customer representative or similar role.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Good knowledge of relevant computer programs and communication medium.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Good English proficiency.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Excellent communication and interpersonal skills.</h6>
              </div>
             
            </div>
         
     
 
</div>


          {/* Right Side Contact Form */}
          <div className="col-lg-5">
            <div className="section_title black mb-4">
             
              <div className="section_main_title">
                <h1>Apply Now</h1>
              </div>
            </div>

            {/* <div className="contact_from">
              <form
                id="contact_form"
                action="https://formspree.io/f/myyleorq"
                method="POST"
              >
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form_box mb-30">
                      <input type="text" name="name" placeholder="Name" />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form_box mb-30">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form_box mb-30">
                      <input
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form_box mb-30">
                      <input type="text" name="web" placeholder="Website" />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form_box mb-30">
                      <textarea
                        name="message"
                        cols="30"
                        rows="10"
                        placeholder="Write a Message"
                      ></textarea>
                    </div>
                    <div className="quote_btn">
                      <button className="btn" type="submit">
                        Send Message
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div className="status"></div>
            </div> */}
            <iframe
              id="if15on87"
              src="https://formnx.com/f/career-15on87?iframe=true"
              frameBorder="0"
              style={{ width: '1px', minWidth: '100%', height: '700px' }}
              title="Career Form"
            />
            <script src="https://formnx.com/js/iframeResizer.js"></script>
            <script src="https://formnx.com/js/widget.js"></script>
          </div>
        </div>
      </div>
    </div>
  );
}
